export interface MfeSpec {
  url: string;
  globalKey: string;
}

const PHOTO_EDITOR_URL =
  import.meta.env.VITE_MFE_PHOTO_EDITOR_URL || "http://localhost:5180";

export const MFE_REGISTRY = {
  photoEditor: {
    url: `${PHOTO_EDITOR_URL}/mfe.js`,
    globalKey: "PhodoPhotoEditor",
  } satisfies MfeSpec,
};
